import React from "react"
import {connect} from "react-redux";
import Info from "../common/Info";

export function PartyEdit(props) {
    // PCA/VCA/AP/AR callers never pass `required` -- default true. Approval-stage callers pass
    // the actual stage's is_required flag (a custom Approval Workflow can mark a stage optional).
    const required = props.required === undefined ? true : props.required;

    return (
        <div className="inputs-wrapper" style={{position: "relative"}}>
            <div className="input-basic addspace">
                <input
                    name={props.role}
                    type="email"
                    id={props.role}
                    value={props.email ? props.email : ""}
                    placeholder="email"
                    onChange={(e) => props.onChange(e)}
                    required={required}
                />
                <label htmlFor={props.role} >{props.title}{required && <span> *</span>}</label>
            </div>
            <Info heading={props.title} className="" size="14" >{props.roleInfo}</Info>
        </div>
    )
}


const mapState = (state) => ({

});

export default connect(mapState)(PartyEdit);